import { render, staticRenderFns } from "./SetMenu.vue?vue&type=template&id=42916496&scoped=true&"
import script from "./SetMenu.vue?vue&type=script&lang=js&"
export * from "./SetMenu.vue?vue&type=script&lang=js&"
import style0 from "./SetMenu.vue?vue&type=style&index=0&id=42916496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42916496",
  null
  
)

export default component.exports